
<div >
  <div class="timer-container" style=" width: 10vw;"  >
        <h5>Processo {{processSelected.identifier}}</h5>
        <div class="timer-display" *ngIf="elapsedTime !== '00:00'">{{ elapsedTime }}</div>
        <div *ngIf="elapsedTime !== '00:00'"  style="border-bottom:-2em;height: 3em;justify-content: center;align-items: center;display: flex;padding-top: 1em;">
              <p-button icon="pi pi-check" [rounded]="true" [outlined]="true" label="Finalizar" (onClick)="FinalizarStopwatch()"/>
        </div>
        <ng-lottie [options]="animationStopwatch"  width="10vw" height="12vh" *ngIf="elapsedTime === '00:00'"/>

    </div>
  
</div>